import { getLocale } from "../runtime";

const sv_returntohomepage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tillbaka till startsidan`
};

const returntohomepage = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_returntohomepage(inputs)
	return "returnToHomepage";
};

export { returntohomepage as "returnToHomepage" };